
import PropTypes from 'prop-types'
export const PassShape = PropTypes.shape({
  guest_name: PropTypes.string.isRequired,
  pass_id: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  created: PropTypes.string.isRequired,
  link: PropTypes.string,
  pin: PropTypes.string
});


// WEBPACK FOOTER //
// ./src/specs/index.js